export const preloadImage = (src) => {
  const img = new Image();
  img.src = src;
};

export const preloadImages = (images) => images.forEach(preloadImage);
